export default __webpack_public_path__ + "static/media/02.4a66f25d.jpg";